import { Box, styled } from '@material-ui/core';

export const IconWrapper = styled(Box)({
  background: '#FA2020',
  width: 40,
  height: 40,
  borderRadius: '50%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center'
});

export const TitleContainer = styled(Box)({
  paddingTop: 12,
  display: 'flex',
  alignItems: 'center',
  gap: 8
});

export const ButtonContainer = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  gap: 8
});
